// @flow
export const CANDIDATE_CREATE_REQUEST = 'CANDIDATE_CREATE_REQUEST';
export const CANDIDATE_CREATE_SUCCESS = 'CANDIDATE_CREATE_SUCCESS';
export const BOOKING_CREATE_SUCCESS = 'BOOKING_CREATE_SUCCESS';
export const BOOKING_UPDATE_SUCCESS = 'BOOKING_UPDATE_SUCCESS';
export const MODAL_CANDIDATE_CREATE_SUCCESS = 'MODAL_CANDIDATE_CREATE_SUCCESS';
export const CANDIDATE_CREATE_FAIL = 'CANDIDATE_CREATE_FAIL';
export const CANDIDATE_CREATE_RESET = 'CANDIDATE_CREATE_RESET';
export const PATIENT_SECOND_OPINION_CREATE_REQUEST = 'PATIENT_SECOND_OPINION_CREATE_REQUEST';
export const BOOKING_UPDATE_REQUESTED = 'BOOKING_UPDATE_REQUESTED';
export const PATIENT_SECOND_OPINION_BOOKING_REQUEST = 'PATIENT_SECOND_OPINION_BOOKING_REQUEST';
export const PATIENT_SECOND_OPINION_UPDATE_REQUEST = 'PATIENT_SECOND_OPINION_UPDATE_REQUEST';
